import axios from 'axios'

// iOS Safari対応のAxios設定
export const client = axios.create({
  timeout: 15000, // 15秒タイムアウト
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
